document.addEventListener('DOMContentLoaded', () => {
    const variantjars = document.querySelectorAll('.product-form__input--jar .variant-jar-wrapper input[type="radio"]');

    variantjars.forEach((input) => {
      input.addEventListener('change', (event) => {
        // Remove "selected" class from all jars
        document.querySelectorAll('.product-form__input--jar .variant-jar').forEach((jar) => {
          jar.classList.remove('selected');
        });

        // Add "selected" class to the parent label of the clicked input
        event.target.closest('.product-form__input--jar .variant-jar').classList.add('selected');
      });
    });
  });